export default "__VITE_ASSET__DHHUS4fl__"